import { useState } from "react";
import { Link } from "react-router-dom";
import { LayoutDashboard, Building2, Inbox, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/site/Logo";
import { AdminOverview } from "@/components/admin/AdminOverview";
import { AdminProgrammes } from "@/components/admin/AdminProgrammes";
import { AdminLeads } from "@/components/admin/AdminLeads";

const TABS = [
  { id: "overview", label: "Vue d'ensemble", icon: LayoutDashboard },
  { id: "programmes", label: "Programmes", icon: Building2 },
  { id: "leads", label: "Demandes", icon: Inbox },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const [tab, setTab] = useState("overview");

  return (
    <div className="min-h-screen bg-[#FAF7F2] lg:grid lg:grid-cols-[260px_1fr]" data-testid="admin-dashboard">
      <aside className="bg-[#1A1716] text-white lg:min-h-screen lg:sticky lg:top-0 flex lg:flex-col">
        <div className="hidden lg:flex items-center gap-3 p-6 border-b border-white/10">
          <LogoMark />
          <div className="leading-none">
            <p className="text-sm tracking-[0.3em]">HÉLIUM</p>
            <p className="text-[10px] text-white/50 tracking-[0.25em] mt-1">ADMIN</p>
          </div>
        </div>
        <nav className="flex lg:flex-col flex-1 p-3 gap-1 overflow-x-auto">
          {TABS.map(({ id, label, icon: Icon }) => (
            <button key={id} onClick={() => setTab(id)} data-testid={`admin-tab-${id}`}
              className={`flex items-center gap-3 px-4 py-3 rounded-sm text-sm whitespace-nowrap transition-colors ${tab === id ? "bg-[#C88A58] text-white" : "text-white/70 hover:bg-white/5"}`}>
              <Icon className="h-4 w-4" /> {label}
            </button>
          ))}
        </nav>
        <div className="p-3 lg:border-t border-white/10 flex lg:flex-col gap-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-3 text-sm text-white/60 hover:text-white" data-testid="admin-view-site-link"><ExternalLink className="h-4 w-4" /><span className="hidden lg:inline">Voir le site</span></Link>
          <button onClick={logout} className="flex items-center gap-3 px-4 py-3 text-sm text-white/60 hover:text-white" data-testid="admin-logout-button"><LogOut className="h-4 w-4" /><span className="hidden lg:inline">Déconnexion</span></button>
        </div>
      </aside>
      <main className="p-5 md:p-10 min-w-0">
        <p className="text-xs text-[#756D69]" data-testid="admin-user-email">Connecté : {user.email}</p>
        {tab === "overview" && <AdminOverview onNavigate={setTab} />}
        {tab === "programmes" && <AdminProgrammes />}
        {tab === "leads" && <AdminLeads />}
      </main>
    </div>
  );
}
